import Api from './../api'
import DataLayer from './../data-layer/index'

DataLayer.$extend('genres', {
    getAll() {
        return Api.genres.get()
    },
})
